module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-rio/node_modules/core-js/internals/is-pure.js
// module id = 536
// module chunks = 11